const KG_LB_RATIO = 0.45359237;

export const convertPoundToKilogram = (lb: number | null | undefined) => {
  return Math.round((lb || 0) * KG_LB_RATIO * 100) / 100; // round to 2 decimal places
};

export const convertKilogramToPound = (kg: number | null | undefined) => {
  return Math.round((kg || 0) / KG_LB_RATIO); // round to the nearest whole number
};
